import { Api } from './Api';

const deliveryWaitlistsPathTo = {
  save: (data) => {
    return Api.request({
      url: '/public/delivery_waitlists.json',
      method: 'post',
      data,
    });
  },
};

export default deliveryWaitlistsPathTo;
